<template>
    <div class='login-bg'>
        <div class='login'>
            <transition name='slide-fade'>
                <el-card class="login-box" v-if="show" v-loading="loading">
                    <div class="login-header">
                        <img src="../../assets/logo.svg" class="img-logo" />
                        <p class="login-subtitle">Autentificare</p>
                    </div>
                    <el-form @submit.native.prevent>
                        <el-form-item label="Email">
                            <el-input type="email" v-model="email" placeholder="Emailul dvs" prefix-icon="el-icon-user" @keyup.enter.native="login()"></el-input>
                        </el-form-item>
                        <el-form-item label="Parola">
                            <el-input type="password" show-password v-model="password" placeholder="Parola dvs" prefix-icon="el-icon-lock" @keyup.enter.native="login()"></el-input>
                        </el-form-item>
                        <div class="login-actions">
                            <el-link @click="switchMode()" type="primary" class="f-pass">Am uitat parola</el-link>
                            <el-button type="primary" @click="login()" class="btn-login">Intră în cont</el-button>
                        </div>
                    </el-form>
                </el-card>
            </transition>

            <transition name='slide-fade'>
                <el-card class="login-box" v-if="forgot_password" v-loading="loading">
                    <div class="login-header">
                        <img src="../../assets/logo.svg" class="img-logo" />
                        <p class="login-subtitle">Resetare parolă</p>
                    </div>
                    <el-form @submit.native.prevent>
                        <el-form-item label="Email">
                            <el-input type="email" v-model="email" placeholder="Emailul dvs" prefix-icon="el-icon-user" @keyup.enter.native="login()"></el-input>
                        </el-form-item>
                        <div class="login-actions">
                            <el-link @click="switchMode()" type="primary" class="f-pass">Înapoi la login</el-link>
                            <el-button type="primary" @click="reset_password()" class="btn-login">Trimite</el-button>
                        </div>
                    </el-form>
                </el-card>
            </transition>
        </div>

        <ChangePassword-dialog ref="cpass-dlg" />
    </div>
</template>

<script>
    import settings from "@/backend/LocalSettings";
    import ChangePassword_dialog from "@/pages/Admin/ChangePassword_dialog";
    import Vue from 'vue'

    export default {
        name: "login",
        components: {
            'ChangePassword-dialog': ChangePassword_dialog
        },
        data () {
            return {
                show: false,
                forgot_password: false,
                loading: false,
                email: "",
                password: ""
            }
        },
        methods: {

            switchMode() {
                this.show = !this.show;
                this.forgot_password = !this.forgot_password;
                this.email = "";
                this.password = "";
            },

            checkPass(password) {
                let base = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])[A-Za-z\d\W_]{8,32}$/;
                return password.match(base);
            },

            reset_password: async function() {
                let response = await this.post('utilizatori/forgot_password', {email: this.email});
                if(response.Success){
                    this.$message({type: 'success', message: response.Success});
                } else if(response.Error){
                    this.$message({type: 'error', message: response.Error});
                }
               
                // await this.$router.push("/");
            },

            login: async function() {
                
                try{
                    var response = await this.post('login', { email: this.email, password: this.password, bearer: settings.get_bearer() } );
                    if(settings.get_bearer()=='') {
                        this.$message.error('Nu aveti drept de acces!');
                        return
                    }
                    if( response.Token == null && response.Eroare == 'lipsa bearer'){
                    this.$message.error('Tokenul nu corespunde!');
                    } else if (response.Token == null && response.Eroare == 'IP nepermis'){
                        this.$message.error('Accesul acestui utilizator este limitat!');
                    } else if( response.Token != null && response.Token != '' && !(this.email == '' && this.password == '')){
                        settings.set_token    ( response.Token    );
                        settings.set_drepturi ( response.Rights   );
                        settings.set_user_type( response.UserType );

                        if (this.checkPass(this.password)) {
                            this.$router.push("/rezervari");
                        } else {
                            this.$message({type: 'warning', message: 'Pentru ca parola dumneavoastra nu este sigura, va rugam sa o schimbati'})
                            this.$refs['cpass-dlg'].showPopup = true;
                        }

                    } else {
                        this.$message.error('Date gresite');
                    }
                }catch(error){
                    console.log(error);
                }
                
            },
            post: async function(url, args={}){
                this.loadingVisible      = true;
                var             response = await this.$http.post(url, args );
                this.loadingVisible      = false;
                if( settings.verify_response(response) )
                {
                    return response.body;
                }
            },
        },
        mounted: function() {
            this.show   = true;
        }
    };
</script>

<style lang="less" scoped>

    .login-bg {
        min-height: 100vh;
        background: linear-gradient(135deg, #1a237e 0%, #283593 50%, #1565c0 100%);
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .login {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .login-box {
        width: 400px;
        border-radius: 12px;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
        border: none;
    }

    .login-header {
        text-align: center;
        margin-bottom: 28px;
    }

    .img-logo {
        max-height: 55px;
        margin-bottom: 12px;
    }

    .login-subtitle {
        font-size: 18px;
        font-weight: 600;
        color: #303133;
        margin: 0;
    }

    .login-actions {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 8px;
    }

    .f-pass {
        font-size: 13px;
    }

    .btn-login {
        width: 140px;
    }

    .slide-fade-enter-active {
        transition: opacity 0.3s ease;
    }
    .slide-fade-leave-active {
        transition: opacity 0.2s ease;
        position: absolute;
    }
    .slide-fade-enter, .slide-fade-leave-to {
        opacity: 0;
    }
</style>
